/**
 * FAIR Toast — RedisiginProductPage `117:12250`
 * Center, 40px from bottom, 3000ms (Fair v1 D6 — keep until designer says otherwise).
 * Visual: dark pill · Inter 12 · check / error 12 · underlined muted-on-dark link.
 */

/** Auto-dismiss duration (ms). */
export const FAIR_TOAST_LIFE_MS = 3000

/** Distance from the bottom edge of the viewport / content (px). */
export const FAIR_TOAST_BOTTOM_OFFSET_PX = 40
